import {useEffect,useRef} from 'react';
import '../styles/robot-head.css';

const heads=new Set<HTMLElement>();
let cleanup:(()=>void)|null=null,frame=0,target:{x:number;y:number}|null=null;
const clamp=(value:number)=>Math.max(-1,Math.min(1,value));
function applyGaze(){
 frame=0;
 // Read every rectangle before writing style variables: no per-avatar listeners.
 const positions=[...heads].map(element=>({element,box:element.getBoundingClientRect()}));
 for(const {element,box} of positions){
  let x=0,y=0;
  if(target&&box.width>0&&box.height>0){
   x=clamp((target.x-(box.left+box.width/2))/Math.max(160,innerWidth*.36));
   y=clamp((target.y-(box.top+box.height/2))/Math.max(120,innerHeight*.36));
   const length=Math.hypot(x,y);if(length>1){x/=length;y/=length}
  }
  element.style.setProperty('--robot-look-x',x.toFixed(4));
  element.style.setProperty('--robot-look-y',y.toFixed(4));
  element.style.setProperty('--robot-yaw',(x*7).toFixed(2)+'deg');
  element.style.setProperty('--robot-pitch',(-y*4).toFixed(2)+'deg');
 }
}
function schedule(){if(!frame)frame=requestAnimationFrame(applyGaze)}
function setup(){
 const fine=matchMedia('(hover: hover) and (pointer: fine)'),reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const enabled=()=>fine.matches&&!reduced.matches;
 const reset=()=>{target=null;schedule()};
 const move=(event:PointerEvent)=>{if(event.pointerType==='mouse'&&enabled()){target={x:event.clientX,y:event.clientY};schedule()}};
 const down=(event:PointerEvent)=>{if(event.pointerType!=='mouse')reset()};
 const viewportChange=()=>{if(!enabled())target=null;schedule()};
 window.addEventListener('pointermove',move,{passive:true});
 window.addEventListener('pointerdown',down,{passive:true});
 document.addEventListener('mouseleave',reset);
 window.addEventListener('blur',reset);window.addEventListener('resize',viewportChange,{passive:true});window.addEventListener('scroll',viewportChange,{passive:true,capture:true});
 fine.addEventListener('change',viewportChange);reduced.addEventListener('change',viewportChange);
 cleanup=()=>{window.removeEventListener('pointermove',move);window.removeEventListener('pointerdown',down);document.removeEventListener('mouseleave',reset);window.removeEventListener('blur',reset);window.removeEventListener('resize',viewportChange);window.removeEventListener('scroll',viewportChange,true);fine.removeEventListener('change',viewportChange);reduced.removeEventListener('change',viewportChange);if(frame)cancelAnimationFrame(frame);frame=0;target=null;cleanup=null};
}
export function RobotHead({className=''}:{className?:string}){
 const ref=useRef<HTMLSpanElement>(null);
 useEffect(()=>{const head=ref.current;if(!head)return;heads.add(head);if(!cleanup)setup();schedule();return()=>{heads.delete(head);if(!heads.size)cleanup?.()}},[]);
 return <span ref={ref} className={'ref-agent-orb ref-robot-head robot-tracking-head '+className} aria-hidden="true"><span className="robot-face-shell"><img src="/assets/agent/nibelc-robot-front-shell-small.webp" srcSet="/assets/agent/nibelc-robot-front-shell-small.webp 180w, /assets/agent/nibelc-robot-front-shell.webp 500w" sizes={className.includes('hero')?'210px':'95px'} width={500} height={500} alt="" draggable={false}/><span className="robot-eye robot-eye-left"><span className="robot-iris"><span className="robot-pupil"/></span></span><span className="robot-eye robot-eye-right"><span className="robot-iris"><span className="robot-pupil"/></span></span></span></span>
}
